<template>
    <div class="steps">
        <div class="steps-line"></div>
        <div class="steps-boxs">
            <div v-for="(item,index) in stepsData" :key="index" :class="{active:index === stepsIndex}" class="steps-item"><span>{{ item.value }}</span></div>
        </div>
    </div>
</template>

<script>
export default {
    props: {

        stepsData: {

            type: Array,
            default () {

                return [];

            }
        },
        stepsIndex: {
            type: Number,
            default: 0
        }

    },
    data () {

        return {
           
        };
    
    }
};
</script>

<style lang="less">
.steps{
    width: 100%;
    height: 0.3rem;
    position: relative;
    display: block;
    .steps-line{
        position: absolute;
        top: 50%;
        width: 100%;
        height: 0.01rem;
        background: #dddddd;
    }
    .steps-boxs{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 0.3rem;
        display: flex;
        justify-content:center;
        align-items:center;
        .steps-item+.steps-item{
            margin-left: 0.7rem;
        }
        .steps-item{
            text-align: center;
            span{
                display: inline-block;
                width: 0.3rem;
                height: 0.3rem;
                border-radius: 100%;
                background-color: #eee;
                line-height: 0.3rem;
                text-align: center;
                font-size: 0.16rem;
                font-weight: 500;
                z-index: 100;
            }
            
        }
        .steps-item.active{
            span{
                background: linear-gradient( 150deg, #1e7ff2, #1dc4e4);
                color:#fff;
            }
        }
    }
}

@media @mobile {
    .steps{
        width: 100%;
        height: 0.44rem;
        position: relative;
        display: block;
        .steps-line{
            position: absolute;
            top: 50%;
            width: 100%;
            height: 0.01rem;
            background: #dddddd;
        }
        .steps-boxs{
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 0.44rem;
            display: flex;
            justify-content:center;
            align-items:center;
            .steps-item+.steps-item{
                margin-left: 0.88rem;
            }
            .steps-item{
                text-align: center;
                span{
                    display: inline-block;
                    width: 0.44rem;
                    height: 0.44rem;
                    border-radius: 100%;
                    background-color: #eee;
                    line-height: 0.44rem;
                    text-align: center;
                    font-size: 0.24rem;
                    font-weight: 500;
                    z-index: 100;
                }
                
            }
            .steps-item.active{
                span{
                    background: linear-gradient( 150deg, #1e7ff2, #1dc4e4);
                    color:#fff;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/basic/Steps.vue